module.exports = "<div class=\"container\">\n\t\n\t<h1>\n  qualify-product works!\n</h1>\n<form [formGroup]=\"form\">\n      <formly-form [model]=\"model\" [fields]=\"fields\">\n        <button type=\"submit\" class=\"btn btn-default\" (click)=set()>Submit</button>\n      </formly-form>\n    </form>\n    {{ model | json }}\n    <br>\n    ------------------\n    {{ response | json }}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sachinmacbook/Sites/ngfront/src/app/qualify-product/qualify-product.component.html
// module id = ../../../../../src/app/qualify-product/qualify-product.component.html
// module chunks = main